<template>
  <div>
    <div class="blocks">
      <div class="l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="d-flex align-items-center title-search">
          <h1 class="pr-3">Tags</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control search-input" type="text" v-model="q" @keyup="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
        <div class="col-3 text-right pr-0">
          <button class="btn btn-primary btn-schedule" v-if="$_can('tags.create')" @click="openAddTag">
            Add tag
          </button>
        </div>
      </div>

      <div class="row mobile-hidden">
        <div class="col-11 filters-field">
          <span>Filters:</span>
          <span v-if="filters.company">
            <span class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('company')" />
              Company: {{ companies.find(el => el.id === filters.company).name }}</span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
        <div class="col-1 d-flex justify-content-end">
          <div class="dropdown">
            <button class="btn btn-secondary sort-button sort-button-selected" @click="e => e.stopPropagation()" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
            >
              <i v-if="selectedKey && selectedKey.length" class="fa pr-2" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
              <span v-if="selectedKey === 'created_at'">
                Created date
              </span>
              <span v-else>
                Sort by
              </span>
              <i class="fa fa-caret-down caret" />
            </button>
            <div class="dropdown-menu sort-dropdown dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('created_at')">
                <span :class="[selectedKey === 'created_at' ? 'selected' : '']">
                  Created date
                </span>
                <span>
                  <i v-if="selectedKey === 'created_at'" class="fa" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!tags">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div>
        <div class="blocks">
          <div v-for="(tag, ind) in tags" :key="ind" @click.self="openEditTag(tag)" class="w-100 d-flex align-items-center justify-content-between bg-white rounded p-2 mt-3">
            <div @click.self="openEditTag(tag)" class="mr-3 d-flex justify-content-center" style="min-width: 100px">
              <tag-color :color="tag.color.name" :name="tag.name" input-class="w-auto" />
            </div>
            <template v-if="tag.companies.length > 4">
              <div @click.self="openEditTag(tag)" class="d-flex align-items-center justify-content-start flex-wrap">
                <span v-for="(company,index) in tag.companies" :key="index">{{ index !== 4 && tag.companies.length > 1 ? company.name+', ' : company.name }}&nbsp;</span>
                <span> and <b>{{ tag.companies.length-4 }} more</b></span>
              </div>
            </template>
            <template v-else>
              <div @click.self="openEditTag(tag)" class="d-flex align-items-center justify-content-start flex-wrap">
                <span v-for="(company,index) in tag.companies" :key="index">{{ index !== 4 && tag.companies.length > 1 && index !== tag.companies.length - 1? company.name+', ' : company.name }}&nbsp;</span>
              </div>
            </template>
            <div v-if="$_can('tags.update') || $_can('tags.delete')" class="dropdown">
              <button type="button" class="btn btn-secondary add-filter" :id="'dropdownMenuButton'+ind"
                      data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false"
              />
              <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropdownMenuButton'+ind">
                <button class="dropdown-item nav-link btn"
                        @click="openEditTag(tag)"
                        v-if="$_can('tags.update')"
                >
                  Edit Tag
                </button>
                <button class="dropdown-item nav-link btn"
                        @click="tagDelete = tag"
                        v-if="$_can('tags.delete')"
                >
                  Remove Tag
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row blocks">
          <div class="col-sm-6 mb-1 pl-0 text-black-50"
               v-if="meta.total"
          >
            Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
          </div>
          <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column justify-content-start">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Companies</label>
                      <simple-select v-model="filters.company"
                                     :options="companies"
                                     :input-id="'status-select'"
                                     placeholder="Select Company"
                                     @input="triggerSearch"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="filters.company"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Add Tag -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-show="showAddTag" @click.self="closeAddTag">
        <div class="sidebar-right">
          <div class="tag-form-wrapper">
            <div class="w-100">
              <h1 class="modal-h1 mb-3">
                <button type="button"
                        class="btn btn-back"
                        @click="closeAddTag"
                />
                Add Tag
              </h1>
              <form class="form-right"
                    @submit.prevent="saveAddTag"
                    @keydown="clearError($event)"
                    autocomplete="no"
              >
                <div class="row">
                  <div class="col-6 p-1">
                    <div class="select-wrap">
                      <label>Name: </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="addTag.name"
                        placeholder="Enter Name"
                        maxlength="100"
                      />
                    </div>
                    <error-field :errors="errors" field="name" />
                  </div>
                  <div class="col-6 p-1">
                    <div class="select-wrap">
                      <label>Color:</label>
                      <simple-select v-model="addTag.color"
                                     v-if="colors.length"
                                     :hide-deselect="true"
                                     :options="colors"
                                     placeholder="Select"
                                     @input="errors.clear('tag_color_id')"
                      >
                        <template slot="selected_option" slot-scope="props">
                          <div @click="props.openList()" v-if="props.value" class="pt-2 mt-1 pl-2 pb-1">
                            <tag-color :color="props.value.name" input-class="w-50" />
                          </div>
                          <input type="text" ref="search" class="simple-select-input" @focus="props.openList()" @blur="props.closeList()" @keyup="props.change" :placeholder="props.value ? '' : 'Select'" @change="props.change" />
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">
                              <tag-color :color="props.option.name" />
                            </span>
                          </div>
                        </template>
                      </simple-select>
                    </div>
                    <error-field :errors="errors" field="tag_color_id" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 p-1">
                    <div class="select-wrap">
                      <label>Companies: </label>
                      <multiselect
                        v-if="companies"
                        v-model="addTag.companies"
                        :options="companies"
                        :multiple="true"
                        track-by="name"
                        label="name"
                        @input="errors.clear('companies')"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <error-field :errors="errors" field="companies" />
                  </div>
                </div>
                <div class="buttons-down text-right">
                  <button type="button" class="btn btn-secondary" @click="closeAddTag">
                    Cancel
                  </button>
                  <button class="btn btn-primary ld-ext-right"
                          :disabled="buttonDisabled"
                          :class="loadingButton ? 'running' : ''"
                  >
                    Create
                    <span class="ld ld-ball ld-flip" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Update Tag -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-show="showEditTag" @click.self="closeEditTag">
        <div class="sidebar-right">
          <div class="tag-form-wrapper">
            <div class="w-100">
              <h1 class="modal-h1 mb-3">
                <button type="button"
                        class="btn btn-back"
                        @click="closeEditTag"
                />
                Update Tag
              </h1>
              <form class="form-right" v-if="editTag" @submit.prevent="saveEditTag"
                    @keydown="clearError($event)"
                    autocomplete="no"
              >
                <div class="row">
                  <div class="col-6 p-1">
                    <div class="select-wrap">
                      <label>Name: </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="editTag.name"
                        placeholder="Enter Name"
                        maxlength="100"
                      />
                    </div>
                    <error-field :errors="errors" field="name" />
                  </div>
                  <div class="col-6 p-1">
                    <div class="select-wrap">
                      <label>Color:</label>
                      <simple-select v-model="editTag.color.id"
                                     v-if="colors.length"
                                     :hide-deselect="true"
                                     :options="colors"
                                     placeholder="Select"
                                     @input="errors.clear('tag_color_id')"
                      >
                        <template slot="selected_option" slot-scope="props">
                          <div @click="props.openList()" v-if="props.value" class="pt-2 mt-1 pl-2 pb-1">
                            <tag-color :color="props.value.name" input-class="w-50" />
                          </div>
                          <input type="text" ref="search" class="simple-select-input" @focus="props.openList()" @blur="props.closeList()" @keyup="props.change" :placeholder="props.value ? '' : 'Select'" @change="props.change" />
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">
                              <tag-color :color="props.option.name" />
                            </span>
                          </div>
                        </template>
                      </simple-select>
                    </div>
                    <error-field :errors="errors" field="tag_color_id" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 p-1">
                    <div class="select-wrap">
                      <label>Companies:</label>
                      <multiselect
                        v-if="companies"
                        v-model="editTag.companies"
                        :options="companies"
                        :multiple="true"
                        track-by="name"
                        label="name"
                        @input="errors.clear('companies')"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                    <error-field :errors="errors" field="companies" />
                  </div>
                </div>
                <div class="buttons-down text-right">
                  <button type="button" class="btn btn-delete float-left" @click="tagDelete = originalEditTag">
                    Delete
                  </button>
                  <button type="button" class="btn btn-secondary" @click="closeEditTag">
                    Cancel
                  </button>
                  <button class="btn btn-primary ld-ext-right"
                          :disabled="buttonDisabled"
                          :class="loadingButton ? 'running' : ''"
                  >
                    Update
                    <span class="ld ld-ball ld-flip" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <modal v-if="tagDelete !== null" @close="tagDelete = null">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">Delete Tag: <tag-color :name="tagDelete.name" :color="tagDelete.color.name" input-class="ml-3" /></h4>
      </div>
      <div slot="body">
        <p class="text-center">Are you sure you want to delete tag with name {{ tagDelete.name }}?</p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click="removeTag">Yes</button>
        <button class="btn btn-danger" @click="tagDelete = null">No</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import TagColor from './TagColor';
import Errors from '../../../classes/Errors';
import Modal from '../../Modal';
import Pagination from '../../Pagination';

export default {
  name: 'Tags',
  components: { Pagination, TagColor, Modal },
  data: () => {
    return {
      tags: [],
      filters: {
        company: '',
      },
      showFilters: false,
      ascOrDesc: null,
      selectedKey: null,
      editTag: null,
      originalEditTag: null,
      addTag: {
        name: '',
        color: null,
        companies: [],
      },
      showEditTag: false,
      showAddTag: false,
      q: '',
      timer: null,
      colors: [],
      errors: new Errors(),
      loadingButton: false,
      buttonDisabled: false,
      tagDelete: null,
      meta: {},
      page: '',
    };
  },
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
    clearFiltersButtonShouldBeDisabled() {
      return this.filters.company;
    },
  },
  watch: {
    filters() {
      this.triggerSearch();
    },
    ascOrDesc() {
      this.triggerSearch();
    },
    selectedKey() {
      this.triggerSearch();
    },
  },
  mounted() {
    this.triggerSearch();
    this.getColors();
  },
  methods: {
    getColors() {
      axios
        .get('/values/tag-colors')
        .then(res => {
          this.colors = res.data.data;
        })
        .catch(() => {});
    },
    clearSearch() {
      this.q = '';
      this.page = '';
      this.triggerSearch();
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.triggerSearch();
        }, 500);
      }
    },
    clearFilters() {
      this.q = '';
      this.filters = {
        companyId: '',
      };
      this.triggerSearch();
    },
    triggerSearch() {
      axios
        .get(
          `companies/tags?q=${this.q}&company_id=${
            this.filters.company ? this.filters.company : ''
          }&sort=${
            this.selectedKey && this.ascOrDesc ? `${this.selectedKey}|${this.ascOrDesc}` : ''
          }&page=${this.page}`,
        )
        .then(response => {
          this.tags = response.data.data;
          this.meta = response.data.meta;
        })
        .catch(() => {});
    },
    removeFilter(filterName) {
      this.$set(this.filters, filterName, '');
      this.triggerSearch();
    },
    sortBy(sort) {
      if (this.selectedKey === sort) {
        // eslint-disable-next-line no-unused-expressions
        this.ascOrDesc === 'asc' ? (this.ascOrDesc = 'desc') : (this.ascOrDesc = 'asc');
      } else {
        this.selectedKey = sort;
      }
    },
    openEditTag(tag) {
      this.editTag = { ...tag };
      this.originalEditTag = tag;
      this.showEditTag = true;
    },
    closeEditTag(withRefresh = false) {
      if (withRefresh === true) {
        this.triggerSearch();
      }
      this.originalEditTag = null;
      this.showEditTag = false;
      this.editTag = null;
    },
    openAddTag() {
      this.showAddTag = true;
    },
    closeAddTag(withRefresh = false) {
      if (withRefresh === true) {
        this.triggerSearch();
      }
      this.clearAddTag();
      this.showAddTag = false;
    },
    clearAddTag() {
      this.addTag = {
        name: '',
        color: null,
        companies: null,
      };
    },
    saveAddTag() {
      const requestData = {
        name: this.addTag.name,
        companies: this.addTag.companies.map(company => company.id),
        tag_color_id: this.addTag.color,
      };

      axios
        .post('companies/tags', requestData)
        .then(() => {
          this.closeAddTag(true);
          toastr.success('Successfully created tag');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    saveEditTag() {
      const requestData = {
        companies: this.editTag.companies.map(company => company.id),
        tag_color_id: this.editTag.color.id,
        name: this.editTag.name,
      };

      axios
        .patch(`companies/tags/${this.editTag.id}`, requestData)
        .then(() => {
          this.closeEditTag(true);
          toastr.success('Successfully updated tag');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    removeTag() {
      axios
        .delete(`companies/tags/${this.tagDelete.id}`)
        .then(() => {
          this.triggerSearch();
          this.tagDelete = null;
          this.editTag = null;
          this.originalEditTag = null;
          this.showEditTag = false;
          toastr.success('Successfully deleted tag');
        })
        .catch(() => {
          toastr.error('Server error');
        });
    },
    changePage(pageNum) {
      this.tags = true;
      this.page = pageNum;
      this.triggerSearch();
    },
  },
};
</script>
<style scoped>
.right-form {
  position: relative;
}

.tag-form-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.buttons-down {
  width: 100%;
  border-top: 1px solid #eeeeee;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Tags/Tags.vue